import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { checkoutUrl } from '../data/checkout';
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
  onDark?: boolean;
  className?: string;
};
export function CTAButton({
  label,
  note,
  id,
  onDark = false,
  className = ''
}: CTAButtonProps) {
  return <div className={`mx-auto w-full max-w-xl text-center ${className}`} data-id="element-89" data-mp="2fyscp3cfgxrx">
      <a id={id} href={checkoutUrl} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-cta transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-cta/40 sm:text-lg" data-id="element-90" data-mp="2tykxki19wjrz">
        <CheckCircle2Icon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-91" data-mp="3cnhrgksrda9o" />
        <span data-id="element-92" data-mp="38ptrh3c7krax">{label}</span>
      </a>
      {note && <p className={`mt-3 text-sm leading-relaxed ${onDark ? 'text-white/75' : 'text-muted'}`} data-id="element-93" data-mp="199eksh3gyghs">{note}</p>}
    </div>;
}